// extracted by mini-css-extract-plugin
export var dividerLine = "_8r-3";
export var itemImage = "_8r-9";
export var lightDivider = "_8r-4";
export var modalContent = "_8r-5";
export var modalContentCompact = "_8r-6";
export var productCard = "_8r-a";
export var productImage = "_8r-b";
export var productImageCompact = "_8r-7";
export var productImagePlaceholder = "_8r-c";
export var productImagePlaceholderCompact = "_8r-8";
export var progressBarBackground = "_8r-1";
export var progressBarContainer = "_8r-0";
export var progressBarFill = "_8r-2";